/*
  TODO:
  Handle loading states by subscribing to vuex actions once the following feature is available:
  https://github.com/vuejs/vuex/issues/1098

  IDEA:
  1) Create a vuex plugin and subscribe to store actions

     // Create plugin
     const myPlugin = store => {
       // called when the store is initialized
       store.subscribeAction({
         before () { ..start loading state..  },
         after () { ..end loading state.. }
       })
     }

     // Register plugin
     const store = new Vuex.Store({
        // ...
        plugins: [myPlugin]
     })
*/
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modules = {}
const isDevelopment = process.env.NODE_ENV !== 'production'
const files = require.context('./modules', true, /index\.js$/)

files.keys().forEach((path, i) => {
  let module = files(path)
  Object.keys(module).forEach(item => {
    modules[item] = module[item]
  })
})

export default new Vuex.Store({ strict: isDevelopment, modules })



// WEBPACK FOOTER //
// ./src/store/index.js